/**
 * profile.js
 */

import React from 'react';
import { Container, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useParams } from 'react-router-dom';
import { UserContext } from 'contexts/user/user-context';
import { AppBarContext } from 'contexts/app-bar/app-bar-context';
import useUser from 'utils/use-user';
import PageTitle from 'components/page-title';
import PageTitleForUser from 'components/page-title-for-user';
import Card from 'components/card';
import FeatureBox from 'components/feature-box';
import ProfileView from './view';


const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  cardContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(0),
    },
  },
}));


export default function Profile(props) {
  const classes = useStyles();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });
  const { user } = React.useContext(UserContext);
  const { setAppBar } = React.useContext(AppBarContext);
  const { userId } = useParams();
  const requestedUser = useUser(userId);
  const [profileUser, setProfileUser] = React.useState();
  const [title, setTitle] = React.useState();
  const isLoading = userId && !requestedUser;
  const titleBase = 'Profile';


  React.useEffect(() => {
    document.title = `PACKTRACK - ${titleBase}`;
    const title = <PageTitleForUser title={titleBase} userName={requestedUser?.name || ''} />
    setTitle(title);
    setAppBar(title);
    setProfileUser(userId ? requestedUser : user);
  }, [userId, user, requestedUser, setAppBar]);


  return (
    <Container className={classes.root} data-testid='profile-page'>
      <div style={{ minHeight: 240 }}>
        {!isMobile && <PageTitle iconName="profile" title={title} />}
        <div className={classes.cardContainer}>
          <Card className={classes.cardContainer}>
            <FeatureBox className={classes.root} loading={isLoading} style={{ minHeight: 120 }}>
              {profileUser && <ProfileView user={profileUser} setUser={setProfileUser} />}
            </FeatureBox>
          </Card>
        </div>
      </div>
    </Container>
  )
}